module.exports = __webpack_public_path__ + "img/ufc4.70518ca2.png";